function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.75
}, /*#__PURE__*/React.createElement("path", {
  d: "M634.359 485.582c-58.104-22.47267-116.208-44.94533-174.312-67.418M460.047 418.164c52.24467-31.27333 104.48933-62.54667 156.734-93.82M664.547 401.84l-47.766-77.496M634.359 485.582c10.06267-27.914 20.12533-55.828 30.188-83.742M634.359 485.582c-11.01567 16.63267-22.03133 33.26533-33.047 49.898M601.312 535.48c-23.42167-.0467-46.84333-.0933-70.265-.14M531.047 535.34c-23.66667-39.05867-47.33333-78.11733-71-117.176M460.047 418.164l48.969-109.746M509.016 308.418c24.39567-5.55067 48.79133-11.10133 73.187-16.652M616.781 324.344c-11.526-10.85933-23.052-21.71867-34.578-32.578"
}));

var _ref3 = /*#__PURE__*/React.createElement("style", null, "\n        .face { font: bold 100px sans-serif; }\n    ");

var _ref4 = /*#__PURE__*/React.createElement("text", {
  x: 550,
  y: 380,
  className: "face",
  transform: "rotate(-90 620 370)"
}, "0");

var SvgD10 = function SvgD10(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "453.655792 286.173126 217.537933 255.637604",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgD10, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/D10.d1114b59.svg";
export { ForwardRef as ReactComponent };